<main class="container-fluid">
  <section class="row ml-5 mr-5 mt-4 mb-3 rounded shadow-sm bg-white p-3">
    <header class="row d-flex align-items-center w-100 p-4">
      <div class="col-sm-12 col-md-4 d-flex flex-row">
        <img src="/assets/icons/info-establecimiento.png" class="d-inline-block rounded-circle ml-5" alt="" height="38">
        <label class="ml-3 small text-muted mb-0">Procedimiento para<br><strong
            class="h6 text-dark font-weight-bold">Cambio de Propietario</strong></label>
      </div>
      <div class="col-12 mt-3 ml-5">
        <form [formGroup]="formMatricula" (submit)="buscarEstablecimiento()">
          <div class="row d-flex">
            <div class="form-group col-md-4 col-sm-12">
              <label class="small text-secondary" for="matricula">Ingrese el número de Mátricula mercantil</label>
              <input formControlName="matricula" type="text" class="form-control form-control-sm">
            </div>
            <div class="col-md-4 col-sm-12">
              <button class="btn btn-primary mt-4 w-100" [disabled]="!formMatricula.valid" type="submit">Buscar
                establecimiento</button>
            </div>
            <div class="col-md-4"></div>
          </div>
        </form>
      </div>
    </header>
  </section>
  <ng-container *ngIf="informacionEstablecimiento">
    <section class=" row ml-5 mr-5 mt-4 mb-3 rounded shadow-sm bg-white p-3">
      <section class="col-6 border-right mb-4">
        <section class="row p-5">
          <section class="col-12">
            <footer class="row">
              <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">Datos del establecimiento</h2>
              <div class="col-sm-12 col-md-12">
                <label class="small mb-0">Nombre del establecimiento</label>
                <p><strong>{{informacionEstablecimiento.razon_social_establecimiento}}</strong></p>
              </div>
            </footer>
          </section>
          <section class="col-12 mb-4 mt-1">
            <footer class="row">
              <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">Datos del prestador</h2>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Razón social</label>
                <p><strong>{{informacionEstablecimiento.razon_social_prestador}}</strong></p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Cámara de comercio</label>
                <p><strong>{{informacionEstablecimiento.desc_camara}}</strong></p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Número de identificación</label>
                <p><strong>{{informacionEstablecimiento.numero_identificacion_representante_legal}}</strong></p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Representante Legal</label>
                <p><strong>{{informacionEstablecimiento.nombre_representante_legal}}</strong></p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Correo electrónico</label>
                <p><strong>{{informacionEstablecimiento.correo_electronico_reportado}}</strong></p>
              </div>
            </footer>
          </section>
        </section>
      </section>
      <section class="col-6">
        <section class="row p-5">
          <section class="col-12">
            <form [formGroup]="formPrestador" (submit)="buscarPrestador()">
              <footer class="row">
                <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">Prestador destino</h2>
                <div class="form-group col-sm-12 col-md-4">
                  <label class="small text-secondary" for="numero_identificacion">Número de identificación</label>
                  <input formControlName="numero_identificacion" type="text" class="form-control form-control-sm">
                </div>
                <div class="form-group col-sm-12 col-md-4">
                  <label class="small text-secondary" for="digito_verificacion">Dígito de verificación</label>
                  <input formControlName="digito_verificacion" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-sm-12 col-md-4 w-50">
                  <button class="btn btn-primary mt-4" [disabled]="!formPrestador.valid" type="submit">Buscar
                    prestador</button>
                </div>
              </footer>
            </form>
          </section>
          <ng-container *ngIf="informacionPrestador">
            <section class="col-12 mb-4 mt-1">
              <footer class="row">
                <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">Datos del prestador</h2>
                <div class="col-sm-12 col-md-6">
                  <label class="small mb-0">Razón social</label>
                  <p><strong>{{informacionPrestador.razon_social}}</strong></p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <label class="small mb-0">Cámara de comercio</label>
                  <p><strong>{{informacionPrestador.desc_camara}}</strong></p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <label class="small mb-0">Número de identificación</label>
                  <p><strong>{{informacionPrestador.numero_identificacion_representante_legal}}</strong></p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <label class="small mb-0">Representante Legal</label>
                  <p><strong>{{informacionPrestador.nombre_representante_legal}}</strong></p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <label class="small mb-0">Correo electrónico</label>
                  <p><strong>{{informacionPrestador.correo_electronico_reportado}}</strong></p>
                </div>
              </footer>
            </section>
          </ng-container>
        </section>
      </section>
      <ng-container *ngIf="informacionPrestador">
        <button class="btn btn-primary mt-4 w-25 m-auto margen" (click)="cambiarPropietario()">Realizar cambio</button>
      </ng-container>
    </section>
  </ng-container>
</main>